<template>
  <v-tooltip top>
    <template v-slot:activator="{ on }">
      <v-btn icon @click="$emit(emitState)" v-on="on" :loading="loading">
        <v-icon :small="smallIcon">{{ icon }}</v-icon>
      </v-btn>
    </template>
    <span>{{ $vuetify.lang.t(text, textParameter) }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'tooltipBasic',
  props: {
    emitState: String,
    icon: String,
    text: String,
    textParameter: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    smallIcon: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>

</style>
